import ConstantsStorage from '../../constants/index';

const ACTIONS = ConstantsStorage().DIALOG_ACTIONS;
const TYPES = ConstantsStorage().DIALOG_TYPES;

export function ActionModalShow(template, data = {}) {
  return {
    type: ACTIONS.DIALOG_SHOW,
    template,
    data,
  };
}

export function ActionModalHide(callback) {
  if (callback && _.isFunction(callback)) {
    callback();
  }

  return {
    type: ACTIONS.DIALOG_HIDE,
  };
}

export function ActionModalShowConfirmRegistration(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_CONFIRM_REGISTRATION, data));
  };
}

export function ActionModalShowShareByMail(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_SHARE_LINK, data));
  };
}

export function ActionModalShowChangePassword(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_CHANGE_PASSWORD, data));
  };
}

export function ActionModalShowChangeUserStatus(id, status) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_CHANGE_USER_STATUS, {id, status}));
  };
}

export function ActionModalShowConfirmRemove(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_CONFIRM_REMOVE, data));
  };
}

export function ActionModalShowVideosessionInvite(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_VIDEO_SESSION_INVITE, data));
  };
}

export function ActionModalShowContactCard(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_CONTACT_CARD, data));
  };
}

export function ActionModalShowInvitedDeclined(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_INVITED_DECLINED, data));
  };
}

export function ActionModalShowAddToContacts(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_ADD_CONTACTS, data));
  };
}

export function ActionModalShowLoading(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_LOADING, data));
  };
}

export function ActionModalShowVideoPollRecordSaving(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_VIDEO_POLL_RECORD_SAVING, data));
  };
}

export function ActionModalShowVideoPollInvite(data) {
  return (dispatch) => {
    dispatch(ActionModalShow(TYPES.MODAL_VIDEO_POLL_RECORD_INVITE, data));
  };
}
